// icon
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit';
import { faCalculator } from '@fortawesome/free-solid-svg-icons/faCalculator';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons/faCalendarAlt';
import { faClock } from '@fortawesome/free-solid-svg-icons/faClock';
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck';
import { faDatabase } from '@fortawesome/free-solid-svg-icons/faDatabase';

// GUI Control
import raGUITextControl from '../gui/ui/controls/raTextControl';

import GUICheckboxControl from '../gui/ui/controls/CheckboxControl';
import GUIDatePickerControl from '../gui/ui/controls/DatePickerControl';
import GUINumberControl from '../gui/ui/controls/NumberControl';
import GUISelectControl from '../gui/ui/controls/SelectControl';
import GUITextControl from '../gui/ui/controls/TextControl';
import GUITimePickerControl from '../gui/ui/controls/TimePickerControl';

// TEMPLATE Control
import raTEMPLATETextControl from '../template/ui/common/controls/raTextControl';

import TEMPLATETextControl from '../template/ui/common/controls/TextControl';
import TEMPLATENumberControl from '../template/ui/common/controls/NumberControl';
import TEMPLATECheckboxControl from '../template/ui/common/controls/CheckboxControl';
import TEMPLATEDatePickerControl from '../template/ui/common/controls/DatePickerControl';
import TEMPLATETimePickerControl from '../template/ui/common/controls/TimePickerControl';
import TEMPLATESelectControl from '../template/ui/common/controls/SelectControl';

// CONFIG CONTROL
import raSIDEBARTextControl from '../template/ui/sidebar_items/raTextConfigComponent';

import SIDEBARDatePickerControl from '../template/ui/sidebar_items/DatePickerConfigComponent';
import SIDEBARTimePickerControl from '../template/ui/sidebar_items/TimePickerConfigComponent';
import SIDEBARSelectControl from '../template/ui/sidebar_items/SelectConfigComponent';
import SIDEBARNumberControl from '../template/ui/sidebar_items/NumberConfigComponent';
import SIDEBARTextControl from '../template/ui/sidebar_items/TextConfigComponent';
import SIDEBARCheckboxControl from '../template/ui/sidebar_items/CheckboxConfigComponent';

// Template Control
// special key for control:
// other_properties: {
//     x: "zzz",
//     c: "xxx",
//     ...
// },
// validation_func: function() {
//  // validation function here
// }
//
const CONTROL_TYPES = {
  raText: {
    label: 'Текст',
    icon: faEdit,
    other_properties: {
      maxLength: 0
    },
    source: {
      gui: raGUITextControl,
      template: raTEMPLATETextControl,
      config: raSIDEBARTextControl
    }
  },

  text: {
    label: 'Текстовое поле',
    icon: faEdit,
    other_properties: {
      isMultiLine: false
    },
    source: {
      gui: GUITextControl,
      template: TEMPLATETextControl,
      config: SIDEBARTextControl
    }
  },
  number: {
    label: 'Числовое поле',
    icon: faCalculator,
    other_properties: {
      isInteger: false,
      decimalPlace: 0
    },
    source: {
      gui: GUINumberControl,
      template: TEMPLATENumberControl,
      config: SIDEBARNumberControl
    }
  },
  datepicker: {
    label: 'Дата',
    icon: faCalendarAlt,
    other_properties: {
      isTodayValue: false,
      dateFormat: 'dd/mm/yy'
    },
    source: {
      gui: GUIDatePickerControl,
      template: TEMPLATEDatePickerControl,
      config: SIDEBARDatePickerControl
    }
  },
  timepicker: {
    label: 'Время',
    icon: faClock,
    other_properties: {
      isNowTimeValue: false,
      timeFormat: 'HH:mm' // enhancement later
    },
    source: {
      gui: GUITimePickerControl,
      template: TEMPLATETimePickerControl,
      config: SIDEBARTimePickerControl
    }
  },
  select: {
    label: 'Селектор',
    icon: faDatabase,
    other_properties: {
      isMultiple: false,
      isAjax: false, // is ajax data source or not
      dataOptions: [], // static data source
      ajaxDataUrl: '' // ajax data source
    },
    source: {
      gui: GUISelectControl,
      template: TEMPLATESelectControl,
      config: SIDEBARSelectControl
    }
  },
  checkbox: {
    label: 'Флажок',
    icon: faCheck,
    other_properties: {
      isChecked: false
    },
    source: {
      gui: GUICheckboxControl,
      template: TEMPLATECheckboxControl,
      config: SIDEBARCheckboxControl
    }
  }
};

export { CONTROL_TYPES };
